import React, { useEffect } from 'react'
import {BrowserRouter} from 'react-router-dom'
import {I18nProvider} from '../_metronic/i18n/i18nProvider'
import {LayoutProvider} from '../_metronic/layout/core'
import AuthInit from './modules/auth/redux/AuthInit'
import {Routes} from './routing/Routes'
import {client} from './services/connection/apollo'
import {AuthProvider, useAuth} from './modules/auth/components/Context/authcontext'
import {ApolloProvider} from '@apollo/client'
import secureLocalStorage from 'react-secure-storage'

type Props = {
  basename: string
}



const App: React.FC<Props> = ({basename}) => {
  const {setAuthenticated} = useAuth()
   useEffect(() => {
    const handleBeforeUnload = (event) => {
      console.log('Browser is closing. Clearing session data...');
      // Clear your local tokens or session storage
    //   localStorage.removeItem('token'); 
    //   sessionStorage.clear();
    //   localStorage.clear()
    //   secureLocalStorage.clear(); 

    // // clearSessionData()
    // setAuthenticated(false)
      // Optional: If you need to hit an API to terminate the server-side session
      // navigator.sendBeacon('/api/logout'); 
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);
  return (
    <AuthProvider>
      <ApolloProvider client={client}>
        <BrowserRouter basename={basename}>
          <I18nProvider>
            <LayoutProvider>
              <AuthInit>
                <Routes />
              </AuthInit>
            </LayoutProvider>
          </I18nProvider>
        </BrowserRouter>
      </ApolloProvider>
    </AuthProvider>
  )
}

export {App}
